import API from 'app/api';
import parseResponse from 'app/api/requests/parsers/response';
import { Plans } from 'app/api/entities/plans';

const fetchPlans = ({ sessionId, locale }) =>
  API.Crapi.fetchSubscriptions({ session_id: sessionId, locale })
    .then(parseResponse)
    .then(Plans);

export { fetchPlans };
